import { CloudUpload } from "lucide-react";

function FileUploadSection({
  handleUploadSectionClick,
}: {
  handleUploadSectionClick: () => void;
}) {
  return (
    <div
      onClick={handleUploadSectionClick}
      className="p-6 text-center hover:border-gray-400 transition
        cursor-pointer w-full rounded-lg duration-300 ease-in-out
            border-gray-300 outline-dashed outline-1 outline-[#4a83fe]"
    >
      <CloudUpload className="w-8 h-8 mb-3 text-[#4a83fe] dark:text-gray-400 mx-auto" />
      <p className="mb-1 text-sm text-gray-500 dark:text-gray-400">
        <span className="font-semibold">Click to upload</span>&nbsp;or drag and
        drop
      </p>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        PNG, JPG or PDF
      </p>
    </div>
  );
}

function FileUpload({
  handleUploadSectionClick,
  handleFileChange,
  fileInputRef,
}: {
  handleUploadSectionClick: () => void;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef: React.Ref<HTMLInputElement>;
}) {
  return (
    <>
      <FileUploadSection handleUploadSectionClick={handleUploadSectionClick} />
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        ref={fileInputRef}
        className="hidden"
      />
    </>
  );
}

export default FileUpload;
